import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  Stack,
  Chip,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

import PaymentIcon from '@mui/icons-material/Payment';
import DoneIcon from '@mui/icons-material/Done';
import PendingIcon from '@mui/icons-material/Pending';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import CreditCardIcon from '@mui/icons-material/CreditCard';

import TopNav from './Navbar';
import LeftNavbar from './LeftNav';
import Breadcrumb from './BreadCrump';

import { useNavigate } from "react-router-dom";

const transactions = [
  { id: 'TXN001', date: '2025-07-10', method: 'Credit Card', amount: 120, status: 'SUCCESS' },
  { id: 'TXN002', date: '2025-06-22', method: 'UPI', amount: 89, status: 'PENDING' },
  { id: 'TXN003', date: '2025-06-01', method: 'Credit Card', amount: 200, status: 'FAILURE' },
];

const getStatusChip = (status) => {
  switch (status) {
    case 'SUCCESS':
      return <Chip icon={<DoneIcon />} label="Success" color="success" size="small" />;
    case 'PENDING':
      return <Chip icon={<PendingIcon />} label="Pending" color="warning" size="small" />;
    case 'FAILURE':
      return <Chip icon={<CancelIcon />} label="Failed" color="error" size="small" />;
    default:
      return <Chip label={status || 'Unknown'} size="small" />;
  }
};

const PaymentsPage = () => {
  const [formData, setFormData] = useState({ amount: '', email: '', phone: '', name: '' });
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState('');
  const [orderId, setOrderId] = useState(null);
  const iframeRef = useRef(null);

  const [tabValue, setTabValue] = useState(0);

  const handleChangeForm = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponse(null);

    try {
      const res = await fetch('http://196.216.9.34:5050/api/register-payment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, amount: Number(formData.amount) }),
      });

      const data = await res.json();
      setResponse(data);

      if (data.formUrl) {
        setPaymentUrl(data.formUrl);
        setOrderId(data.orderId);
        setOpenModal(true);
      }
    } catch (err) {
      setResponse({ error: err.message });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (iframeRef.current) {
        try {
          const iframeUrl = iframeRef.current.contentWindow.location.href;
          if (iframeUrl.includes("http://196.216.9.34:3003/payments")) {
            setOpenModal(false);
            clearInterval(interval);

            if (orderId) {
              fetch(`http://196.216.9.34:5050/api/payment-status/${orderId}`)
                .then((res) => res.json())
                .then((statusData) => {
                  setResponse((prev) => ({
                    ...prev,
                    finalStatus: statusData.status,
                  }));
                })
                .catch((err) => console.error("Failed to fetch payment status:", err));
            }
          }
        } catch (e) {
          // Ignore cross-origin errors
        }
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [orderId]);

  return (
    <Box sx={{ display: 'flex' }}>
      <LeftNavbar />
      <Box sx={{ flexGrow: 1, ml: { lg: '240px' } }}>
        <TopNav />
        <Box sx={{ p: 10, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
          <Breadcrumb currentPage="Payments" />

          <Typography variant="h4" fontWeight="bold" sx={{ mb: 4, color: '#ff6600' }}>
            <PaymentIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Payments
          </Typography>

          {/* Tabs */}
          <Tabs
            value={tabValue}
            onChange={(e, newValue) => setTabValue(newValue)}
            sx={{ mb: 3 }}
          >
            <Tab label="Register Payment" />
            <Tab label="Previous Transactions" />
          </Tabs>

          {/* Register Payment Tab */}
          {tabValue === 0 && (
            <>
              <Card sx={{ mb: 4, boxShadow: 2 }}>
                <CardContent>
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Amount"
                          name="amount"
                          type="number"
                          value={formData.amount}
                          onChange={handleChangeForm}
                          fullWidth
                          required
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Email"
                          name="email"
                          type="email"
                          value={formData.email}
                          onChange={handleChangeForm}
                          fullWidth
                          required
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChangeForm}
                          fullWidth
                          required
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Name"
                          name="name"
                          value={formData.name}
                          onChange={handleChangeForm}
                          fullWidth
                          required
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button type="submit" variant="contained" color="primary" disabled={loading}>
                          {loading ? 'Processing...' : 'Register Payment'}
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </CardContent>
              </Card>

              {response && (
                <Card sx={{ boxShadow: 2 }}>
                  <CardContent>
                    <Typography variant="h6" fontWeight="medium" sx={{ mb: 2 }}>
                      Payment Response
                    </Typography>
                    <Stack spacing={1}>
                      {Object.entries(response).map(([key, value]) => (
                        <Stack key={key} direction="row" alignItems="center" spacing={1}>
                          <Avatar sx={{ bgcolor: '#ff6600', width: 24, height: 24 }}>
                            {key[0].toUpperCase()}
                          </Avatar>
                          <Typography variant="body2">
                            <strong>{key}:</strong> {typeof value === 'object' ? JSON.stringify(value) : value}
                          </Typography>
                          {key.toLowerCase().includes('status') && getStatusChip(value)}
                        </Stack>
                      ))}
                    </Stack>
                  </CardContent>
                </Card>
              )}

              <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth maxWidth="md">
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  Complete Payment
                  <IconButton onClick={() => setOpenModal(false)}>
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent sx={{ height: '80vh', p: 0 }}>
                  <iframe
                    ref={iframeRef}
                    src={paymentUrl}
                    title="Payment Gateway"
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                  />
                </DialogContent>
              </Dialog>
            </>
          )}

          {/* Previous Transactions Tab */}
          {tabValue === 1 && (
            <Card sx={{ boxShadow: 2 }}>
              <CardContent>
                <Typography variant="h6" fontWeight="medium" sx={{ mb: 2 }}>
                  Recent Transactions
                </Typography>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell><strong>ID</strong></TableCell>
                      <TableCell><strong>Date</strong></TableCell>
                      <TableCell><strong>Method</strong></TableCell>
                      <TableCell><strong>Amount (k)</strong></TableCell>
                      <TableCell><strong>Status</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {transactions.map((txn) => (
                      <TableRow key={txn.id}>
                        <TableCell>{txn.id}</TableCell>
                        <TableCell>{txn.date}</TableCell>
                        <TableCell>
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <CreditCardIcon fontSize="small" />
                            <Typography variant="body2">{txn.method}</Typography>
                          </Stack>
                        </TableCell>
                        <TableCell>{txn.amount}</TableCell>
                        <TableCell>{getStatusChip(txn.status)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default PaymentsPage;
